import {HAS_ERROR_ACTION, SET_LOGGED_IN_USER, SET_LOGIN_ERROR_MESSAGE, SET_USER_VALIDATION_ERRORS, UPDATE_USER} from '../actions/auth';
import {User} from '../../incase-domain/user';
import {AuthReducerType} from '../actions/types/auth.types';
import {TypedTranslation} from '../../i18n';

export interface AuthReducerState {
    hasError: boolean;
    loginErrorMessage: TypedTranslation | null;
    loggedInUser?: User;
    isLoggedIn: boolean;
    validationErrors?: Record<string, string[]>;
    isUserUpdating: boolean;
}

export const preloadedState = {
    hasError: false,
    loginErrorMessage: null,
    isLoggedIn: false,
    validationErrors: {},
    isUserUpdating: false,
};

export const authReducer = (state: AuthReducerState = preloadedState, action: AuthReducerType): AuthReducerState => {
    switch (action.type) {
        case HAS_ERROR_ACTION:
            return {...state, hasError: action.payload};
        case SET_LOGIN_ERROR_MESSAGE:
            return {...state, loginErrorMessage: action.payload};
        case SET_LOGGED_IN_USER:
            return {...state, loggedInUser: action.user, isLoggedIn: !!action.user, isUserUpdating: false};
        case UPDATE_USER:
            return {...state, isUserUpdating: true};
        case SET_USER_VALIDATION_ERRORS:
            return {...state, validationErrors: action.errors, isUserUpdating: false};
        default:
            return state;
    }
};
